// Module
var code = "<div class=\"full-height\" layout=\"column\"> <bringoz-items-list-display items=\"$ctrl.agentsNames\" max-items=\"$ctrl.maxItems\"> </bringoz-items-list-display> </div> ";
// Exports
export default code;